import { render } from "./StrokedStarIcon.vue?vue&type=template&id=2c42f47a"
import script from "./StrokedStarIcon.vue?vue&type=script&lang=js"
export * from "./StrokedStarIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__